var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchasing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.751,
    height: 22.61,
    viewBox: "0 0 18.751 22.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M18.777,18.656v-.015L17.4,7.93A3.643,3.643,0,0,0,13.8,4.707V4.48a4.381,4.381,0,0,0-8.763.005v.223a3.643,3.643,0,0,0-3.6,3.218L.067,18.641v.015a3.653,3.653,0,0,0,3.617,4.063H15.149a3.653,3.653,0,0,0,3.623-4.068ZM7.165,4.485a2.257,2.257,0,1,1,4.513,0v.223H7.165Zm9.122,15.6a1.5,1.5,0,0,1-1.133.506H3.684A1.508,1.508,0,0,1,2.167,18.9L3.553,8.2v-.01A1.523,1.523,0,0,1,5.071,6.837h8.712A1.518,1.518,0,0,1,15.3,8.188V8.2l1.376,10.711a1.493,1.493,0,0,1-.379,1.184Z",
    transform: "translate(-0.044 -0.109)",
    fill: "#f9fafa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchasing);
export default __webpack_public_path__ + "static/media/purchasing.933877dbc98f718496daef0b855de6ae.svg";
export { ForwardRef as ReactComponent };